import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import Form from 'react-bootstrap/Form';
import Graph from '../../components/Graph';
import { MdClear, MdSearch } from 'react-icons/md';
import { FaPrint } from 'react-icons/fa';
import { FaCalendarAlt } from 'react-icons/fa';
import Button from 'react-bootstrap/Button';
import DatePicker from 'react-multi-date-picker';
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import Spinner from 'react-bootstrap/Spinner';
import { API } from 'aws-amplify';
import moment from 'moment';

import { useToasts } from 'react-toast-notifications';

const params = { 
    headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,        
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
}

const QueueDetTrend = (props) => {
    const { addToast } = useToasts();
    const [asset, setAsset] = useState();
    const [assets, setAssets] = useState([]);
    const [timeFrom, setTimeFrom] = useState(new Date().setHours(0,0,0));
    const [timeTo, setTimeTo] = useState(new Date().setHours(23,59,0));
    const [dateSel, setDateSel] = useState([new Date()]);
	const [isLoading, setIsLoading] = useState(false);
	const [isLoadingCounts, setIsLoadingCounts] = useState(false);
    const [counts, setCounts] = useState([]);
    const [rGraph, setRGraph] = useState([]);
    
    const [location, setLocation] = useState('');
	const [locationList, setLocationList] = useState([]);
	const [assetList, setAssetList] = useState([]);

    const [relays, setRelays] = useState([]);

    let formatDate = ['DD-MM-YYYY','DD/MM/YYYY']
    if (props.formatDate!==formatDate[0]){
        formatDate = ['MM-DD-YYYY','MM/DD/YYYY']
    } 

    // Load asset 
    /* eslint-disable no-alert, no-console */
    useEffect(()=>{
        const fetchAssets = async () => {
            setIsLoading(true);  
            
            const data = await API.get('asset','/', params)
            data.sort((a, b) => (a.name > b.name) ? 1 : -1)
            
            //Get user asset list
            let user_assets = []
            if (props.user && props.user.username)
                user_assets = await API.get('user_assets','/' + props.user.username, params)

            let assetsFiltered = []
            if (user_assets && user_assets.assets){
                user_assets = user_assets.assets;
                assetsFiltered = data.filter(x => user_assets.find(i => i === x.id));
            }
            
            if (assetsFiltered.length>0){
                setAssets(assetsFiltered);
                setAssetList(assetsFiltered);
            }
            
            setIsLoading(false);
        }
         
        if (props.user && Object.keys(props.user).length !== 0)
            fetchAssets();
 			
    }, [props.user]);

    // Set relays
    useEffect(()=>{
        // clean counts
        setCounts([]);
        setRGraph([]);

        // asset relays
        let arr = [] ; 
        const assetRelays = assetList.find(i => i.id === asset) && assetList.find(i => i.id === asset).relays 
        for (let i = 0; i < 16; i++) {
            
            let label = ['R',i+1].join('');
            if (assetRelays && assetRelays.find(item => item.id ===  label) && assetRelays.find(item => item.id ===  label).label !=='')
                label = assetRelays.find(item => item.id ===  ['R',i+1].join('')).label

            arr = [...arr, 
            {
                relay: ['R',i+1].join(''), 
                label: label, 
                checked:true,
                disabled: false
            }]
        }
 
        setRelays(arr);
              
    },[asset, assetList])
    

    // Load location
	useEffect(()=>{
		const fetchLocation = async () => {
            const loc = [...new Set(assets.map(item => item.location))];
			setLocationList(loc);
            if (loc.length === 1)
                setLocation(loc[0]);
		}
        fetchLocation();	
    }, [assets]);

    useEffect(() => {
        const handleSearch = () => { 		
            let results = assets;   
            // Location
            if (location){
                results = results.filter(results =>
                    (results.location && results.location.toLowerCase().includes(location.toLowerCase()))
            )}             
            setAssetList(results);           
        }
		handleSearch();
    }, [location, assets]); 

    // Load counts
    // Fetch hourly counts filter by asset, date and time range
    const fetchCounts = async () => {
        setIsLoadingCounts(true); 

        let result = []
        dateSel.sort((a, b) => (a > b) ? 1 : -1)

        for (let i = 0; i < dateSel.length; i++){
            const dtF = new Date(dateSel[i])
            
            const dtFrom = moment.utc(dtF).local().format('YYYY-MM-DD')
            const tiFrom = moment.utc(timeFrom).local().format('HH:mm:ss');          
            let  dateStart = moment(dtFrom + ' ' + tiFrom).toISOString();

            const dtTo = moment.utc(dtF).local().format('YYYY-MM-DD')
            const tiTo = moment.utc(timeTo).local().format('HH:mm:ss');          
            let  dateEnd = moment(dtTo + ' ' + tiTo).toISOString();
        
            if (dateEnd >= dateStart){
                const filter = asset +'?start='+ dateStart +'&end='+ dateEnd

                let data = []
                await API.get('hourly_queue','/'+ filter, params)
                .then(resp => {
                    data = resp
                    // console.log(resp)
                }).catch(error => {
                    console.log(error)
                    addToast('Error Loading Data', { appearance: 'error' });
                    setIsLoadingCounts(false);
                });  
            
                // setCounts(data);
                result.push(data)
            } else {
                addToast('Error incorrect dates', { appearance: 'error' });
            }
        }
        setCounts(result);
        // console.log(result)
        setIsLoadingCounts(false); 

    }


    useEffect(() => { 
        // Queue by Relay
        const getQCount = () => {
            
            const relayCharts = []
            const dt = moment.utc(new Date()).local().format('YYYY-MM-DD')
            const colors = [ 
                'rgba(255, 99, 132, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 205, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)',
                'rgba(63, 178, 191, 1)',
                'rgba(208, 218, 98, 1)',
                'rgba(201, 203, 207, 1)',
                'rgba(100, 218, 98, 1)']

            relays.forEach((item) => {
                let data = [];
                let ds = [];

                for (let j = 0; j < counts.length; j++){
                    
                    data = counts[j].map(i => ({ 
                        DATE_ISO: i.date_iso, 
                        DATE: moment.utc(new Date(i.date_iso)).local().format('YYYY-MM-DD'), 
                        TIME: moment(dt + ' ' + moment.utc(new Date(i.date_iso)).local().format('HH:mm')).toISOString(), 
                        VALUE: i[item.relay]}))
                
                    // remove duplicates 
                    data = removeDupes(data);
                    // data.sort((a, b) => (a.TIME > b.TIME) ? 1 : -1);

                    data = data.filter(i => i.VALUE > 0)

                    // count = data.map(i =>  i.VALUE).reduce((sum, item) => { return sum += parseInt(item) }, 0)

                    if (data.length > 0){

                        const dt = data.map(i => ({
                            x: i.TIME, 
                            y: i.DATE,
                            // y: data.filter(x => (x.TIME).split(':')[0] === (i.TIME).split(':')[0]).length, 
                            // r: data.filter(x => (x.TIME).split(':')[0] === (i.TIME).split(':')[0]).reduce((sum, item) => { return sum += parseInt(item.VALUE) }, 0),
                            // r1: data.filter(x => (x.TIME).split(':')[0] === (i.TIME).split(':')[0]).reduce((sum, item) => { return sum += parseInt(item.VALUE) }, 0),
                            r1: moment.utc(new Date(i.DATE_ISO)).local().format('HH:mm A'),
                        }))

                        const lb = data.map(i =>   moment.utc(new Date(i.DATE)).local().format('MMM D'))

                        ds.push({
                            label: removeDupes(lb),
                            borderColor: colors[j % colors.length], 
                            backgroundColor: colors[j % colors.length], 
                            data: removeDupes(dt),
                            })
                        
                    }

                }          

                

                if (ds.length > 0){                    
                    relayCharts.push({
                        label: item.label,
                        relay: item.relay,
                        chart: { 
                            datasets: ds
                        }
                    });
                }else{
                    item.disabled = true;
                }
               
            })
           
            setRGraph(relayCharts)
        }
        if (counts.length>0)
            getQCount();
    },[counts, relays]);

    // Graph options
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        // interaction: {
        //   intersect: false,
        //   axis: 'x'
        // },
        plugins: {        
            legend: { 
                display: true,
                position: 'right',
                labels: {
                    boxWidth: 10,
                },
            }, 
            tooltip: {
                callbacks: {
                    label: function(context) {
                        let label = context.dataset.label || '';
                        // console.log(context)
                        if (label) {
                            label += ': ';
                        }
                        if (context.raw.r1 !== null) {
                            label += context.raw.r1
                        }
                        return label;
                    }
                }
            }
        },
        scales: {
            x: {
              type: 'time',
              display: true,
            //   title: {
            //     display: true,
            //     text: 'Time'
            //     },
              grid: {
                  display: false
              },
              time: {
                unit: 'hour',
                displayFormats: {
                    hour: "hA"
                },
               },
              ticks: {
                    suggestedMin: new Date().setHours(0,0,0),
                    suggestedMax: new Date().setHours(23,59,0),
                    // autoSkip: true,
                    // maxRotation: 0,
                    major: {
                        enabled: true
                      },
                    //   color: (context) => context.tick && context.tick.major && '#FF0000',
                    font: function(context) {
                        if (context.tick && context.tick.major) {
                          return {
                            weight: 'bold'
                          };
                        }
                      }
                }
                
            },
            y: {
              display: true,
              type: 'time',
              time: {
                    unit: 'day',
              },
              grid: {
                display: true
              },
            //   title: {
            //     display: true,
            //     text: 'Date'
            //   }
            }
          }

    };
    

    const removeDupes = (arr) =>{
        // remove duplicates 
        arr = arr.map(JSON.stringify);
        arr = new Set(arr);
        arr = Array.from(arr).map(JSON.parse);
    return arr
    }

    const handleClearSearch = () => {
        setTimeFrom(new Date().setHours(0,0,0));
        setTimeTo(new Date().setHours(23,59,0));
        // setAsset(assets[0].id);
        setAsset('');		
        setDateSel([new Date()]);
        // setDateSelTo(new Date());
        setCounts([]);
        // setCountsh([]);
        setRGraph([]);
        if (locationList.length === 1)
            setLocation(locationList[0]);
        else
            setLocation('');

    }

    const handleSearch = () => {
        setCounts([]);
        setRGraph([]);

        if (asset){
            fetchCounts();
        }
    }

    const handleCheckList = (e) => {
        // Update target
        
        const target  = relays.find(i => i.relay === e.target.id)
        target.checked = e.target.checked
        setRelays([...relays]);
    }
    
    // check all relays 
    const handleCheckAll = (e) => {
        // update user list
        relays.map(item => item.checked =  e.target.checked)
        setRelays([...relays]);      
    }

    const startTime = new Date();
    startTime.setHours(23,59,0);

    return (         
        <div className="QueueDet">
            <div className="col-md-12">
                <div className="row header">Queue Detection Trend</div>
            </div>
            {(!isLoading) ? (
            <div>
            <div className="col-md-12 pt-0 div-content">
            <div className="row">
                <div className="col-12 p-2 d-flex rounded bg-light">  
                    <div className="col-10">  
                    <div className="row"> 
                        <div className="col-4"> 
                            <Form.Group controlId="location" >
                            <Form.Label>Location</Form.Label>
                            <Form.Control 
                                as="select" 
                                value={location} 
                                onChange={e => {setLocation(e.target.value)}}>
                                    <option key='locs' value=''>Select Location</option>
                                    {locationList.map((item, i) =>
                                        <option key={item} value={item}>{item}</option>
                                    )}
                            </Form.Control>  
                            </Form.Group>
                            <Form.Group controlId="asset" >
                                <Form.Label>Asset</Form.Label>
                                <Form.Control                            
                                    as="select" 
                                    value={asset}
                                    onChange={e => {setAsset(e.target.value)}}
                                    >  
                                    <option key='assetList' value=''>Select Asset</option>
                                    {assetList.map((item, i) =>
                                    <option key={item.id} value={item.id}>{item.name}</option>
                                    )}
                                </Form.Control>  
                            </Form.Group>
                        </div>
                        <div className="col-8">
                            <div className="row">
                                <div className="col-md-4"> 
                                    <Form.Group controlId="date_from">
                                    <Form.Label><FaCalendarAlt className="text-secondary" /> Dates</Form.Label>
                                    <div> 
                                    <DatePicker 
                                        multiple
                                        format={formatDate[1]} 
                                        value={dateSel} 
                                        onChange={setDateSel}
                                        plugins={[
                                            <DatePanel sort="date"/>
                                        ]}
                                        maxDate={new Date()}
                                        inputClass="form-control"
                                        />
                                    </div>
                                    </Form.Group>
                                </div>
                                    
                                <div className="col-md-12">
                                <div className="d-flex flex-wrap border rounded p-2">
                                <div className="col-sm-3" key="chkAll">
                                <Form.Check 
                                    inline 
                                    label="All"
                                    type="checkbox" 
                                    id="chkAll" 
                                    defaultChecked="true"
                                    onChange={handleCheckAll}
                                    /> 
                                </div>
                                {relays.map((item, i) =>  
                                    (item.label !=='' && item.label !== undefined)? 
                                    <div key={"chk"+i} className="col-sm-3">                           
                                    <Form.Check 
                                        inline 
                                        label={item.label}
                                        type="checkbox" 
                                        id={item.relay} 
                                        checked={item.checked}
                                        onChange={handleCheckList}
                                        disabled={item.disabled}
                                        />  
                                    </div>   
                                    :''                                   
                                )}
                                </div>  
                            </div>

                            </div>
                            </div>
                        </div>
                    </div>
                    <div className="text-nowrap">  
                        <Button variant="info" size="sm" onClick={handleSearch} className="mr-1 text-nowrap" disabled = {isLoadingCounts? true : false} >
                            <MdSearch /> Search
                        </Button>  
                        <Button variant="danger" size="sm" onClick={handleClearSearch} >							
                            <MdClear /> 
                        </Button>
                    </div>
                    <div className="w-100 text-right print"> 
                        <Button variant="light" size="sm" onClick={() => window.print()} >							
                            <FaPrint /> Print 
                        </Button>
                    </div>
                </div>
                </div>
                <div className="col-md-12 text-center">
                    {(isLoadingCounts) ? (
                    <>
                    <Spinner animation="grow" size="sm" role="status" variant="warning" /> 
                    <span className="text-secondary">  Loading...</span>
                    </> 
                    ): ''} 
                </div>
                <div className="row p-2">                   
                   {rGraph.map((item, i) => 
                        (relays.find(i => i.relay === item.relay).checked)?
                        <div key={"chart" + i} className="col-md-12">
                            <h3 className="text-header pt-4">{item.label}</h3>
                            <Graph 
                                type="scatter"
                                data={item.chart}
                                options={options}
                            />  
                        </div>  
                        :''      
                   )}

                </div>
                </div>
            </div>
            ):(
                <div className="col-md-12">
                <Spinner animation="grow" size="sm" role="status" variant="warning" /> 
                <span className="text-dark">  Loading...</span>
                </div>
                )}
        </div>    
    )
}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        formatDate: state.auth.formatDate,
    };
  };

export default connect(mapStateToProps)(QueueDetTrend);